import React from 'react'
import { inject, observer } from 'src/core/store'
import './index.less'
import { history } from 'src/core/router'
import brower from 'src/helper/brower'
import jump from 'src/helper/jumpToApp'
import { getlang } from 'src/helper/getlang'
import { setDocumentTitle } from 'src/helper/tool'

import Toast from 'src/component/Toast'

const { appLink } = jump
const { AppStore, googlePlay, apkURL, apkHW } = appLink

@inject('store')
@observer
export default class extends React.Component {
  state = {
    langListState: false, // 语言列表显示隐藏
    qrCodeState: 0, // QR码显示隐藏
    langMode: 'en', // 默认语言
    lang: {}, // 语言对象
    acState: 0, // 关于和联系显示隐藏
    initShareTraceOut: false,
    keyCode: '',
    urlApple: AppStore,
    urlHuaWei: apkHW,
    urlAndroid: googlePlay,
    urlApk: apkURL,
    wenfrg: false,
    isShowApkAndRecharge: true,
    showGOLDEN: false,
    companyName: '',
  }

  constructor(props) {
    super(props)
    this.homePcStore = this.props.store.register('home/pcnew')
    setDocumentTitle(`Yayya - Free group voice chat app`)
  }

  async showToast() {
    this.setState({
      toastContent: 'Coming soon...',
    })
    this.refs.toast.hideRule(true)
  }

  goMoblie() {
    if (brower.isIphone() || brower.isAndroid() || brower.isWeixin()) {
      history.push({
        pathname: `/`,
        query: {
          code: this.props.location.query.code,
          c: this.props.location.query.c,
          activity: this.props.location.query.activity,
        },
      })
    }
  }

  async componentWillMount() {
    // 根据设备类型跳转到指定网页
    let targetUrl = 'https://web.yayya.chat/' // 默认跳转地址
    if (brower.isIphone()) {
      // iOS 设备跳转到 yayya.live
      targetUrl = 'https://web.yayya.live/'
    } else if (brower.isAndroid()) {
      // Android 设备跳转到 yayya.chat
      targetUrl = 'https://web.yayya.chat/'
    }
    window.location.href = targetUrl
  }

  selectDomain() {
    const domain = window.location.hostname
    if (domain.endsWith('yayya.chat')) {
      return '广州次境互联科技有限公司'
    } else if (domain.endsWith('yayya.live')) {
      return '广州光之夜科技有限公司'
    } else {
      return '广州光之夜科技有限公司'
    }
  }

  async componentDidMount() {
    const meta1 = document.createElement('meta')
    meta1.httpEquiv = 'Cache-Control'
    meta1.content = 'no-store, no-cache, must-revalidate, max-age=0'

    const meta2 = document.createElement('meta')
    meta2.httpEquiv = 'Pragma'
    meta2.content = 'no-cache'

    const meta3 = document.createElement('meta')
    meta3.httpEquiv = 'Expires'
    meta3.content = '0'

    document.head.appendChild(meta1)
    document.head.appendChild(meta2)
    document.head.appendChild(meta3)

    this.initLang()

    this.setState({
      keyCode: this.props.location.query.code || '',
    })
  }

  /**
   * @description 初始化浏览器语言设置
   */
  async initLang() {
    let language = await getlang()
    if (language === 'zh') {
      language = 'en'
    }
    console.log('language', language)
    let lang = await this.homePcStore.getLang(language)
    this.setState({
      lang: lang,
    })
  }

  /**
   * @description 设置语种
   * @param mode string
   */
  async setLangMode(mode) {
    let langMode = await this.homePcStore.getLang(mode)
    console.log(langMode)
    this.setState({
      lang: langMode,
    })
  }

  /**
   * @description 改变语种
   * @param state Index
   */
  changeLangMode(state) {
    if (state == 'English') {
      this.setLangMode('en')
    }
    if (state == 'بالعربية') {
      this.setLangMode('ar')
    }
    if (state == 'Türkçe') {
      this.setLangMode('tr')
    }
    if (state == '中文') {
      this.setLangMode('zh')
    }
    if (state == 'Português') {
      this.setLangMode('pt')
    }
    if (state == 'indonésio') {
      this.setLangMode('id')
    }

    if (state === 'Русский') {
      this.setLangMode('ru')
    }

    if (state === "O'zbek") {
      this.setLangMode('uz')
    }

    if (state === 'فارسی') {
      this.setLangMode('fa')
    }

    if (state === 'اردو') {
      this.setLangMode('ur')
    }
  }

  /**
   * @description 移入移出语言列表显示
   * @param state true | false
   */
  changeLangListState(state) {
    this.setState({
      langListState: state,
    })
  }

  /**
   * @description 二维码显示
   * @param state true | false
   */
  changeQRState(state) {
    this.setState({
      qrCodeState: state,
    })
  }

  /**
   * @description 弹窗显示
   * @param state true | false
   */
  changeAcState(state) {
    this.setState({
      acState: state,
    })
  }

  /**
   * @description APK跳转
   */
  handleApk = () => {
    console.log('apk')
    this.showToast()
  }

  /**
   * @description Android跳转
   */
  handleAndroid() {
    console.log('android')
    this.showToast()
  }
  /**
   * @description HuaWei跳转
   */
  handleHuaWei() {
    console.log('HuaWei')
    this.showToast()
  }
  /**
   * @description Apple跳转
   */
  handleApple() {
    console.log('apple')
    this.showToast()
  }

  /**
   * @description 充值跳转
   */
  handleRecharge() {
    // history.push('/app/recharge')
    // window.location.href = isRussiaHost() ? config.hostHybridRu : config.hostHybrid + hybridRouter.recharge
  }

  jumpPage() {
    history.push({
      pathname: `/app/termsofuse`,
      query: {},
    })
  }

  render() {
    let {
      langListState,
      qrCodeState,
      lang,
      language,
      toastContent,
      acState,
      isShowApkAndRecharge,
    } = this.state
    console.log(qrCodeState, '---qrCodeState---')
    return (
      <div className={`home-content ${[2, 9, 10].includes(lang.mode) && 'arLangMode'}`}>
        <div className="content">
          <div className="top">
            <div className="chatie-logo">
              <img src="/img/home/logo@2x.png" alt="" />
            </div>
            <div className="right">
              {
                // isShowApkAndRecharge === true && (
                //   <div
                //     style={{ unicodeBidi: `${this.state.language == 'ar' && 'bidi-override'}` }}
                //     className="recharge"
                //     onClick={() => {
                //       this.handleRecharge()
                //     }}
                //   >
                //     {lang.recharge}
                //   </div>
                // )
              }
              <div
                style={{ margin: `${lang.mainLang == 'بالعربية' ? '0 12px 0 0' : ''}` }}
                onMouseEnter={() => {
                  // this.changeLangListState(true)
                }}
                onMouseLeave={() => {
                  // this.changeLangListState(false)
                }}
                className="lang"
              >
                <div className="arrow"></div>
                {/* 需要显示的语种的文字 */}
                {/* <div className="lang-txt">{lang.mainLang}</div> */}
                {/* 语种列表 */}
                {langListState && (
                  <div className={`lang-list ${lang.mainLang == 'بالعربية' ? 'lang-list-ar' : ''}`}>
                    {lang.langList.map((item, index) => {
                      return (
                        <div
                          key={index}
                          className="lang-item"
                          // onClick={this.changeLangMode.bind(this, lang.langList[index])}
                        >
                          {/* {lang.langList[index]} */}
                        </div>
                      )
                    })}
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="center">
            <div className="left">
              <div className="title">{lang.title1}</div>
              <div className="desc" dangerouslySetInnerHTML={{ __html: '&nbsp;' }} />
              <div className="app-download">
                <div
                  // onMouseEnter={this.changeQRState.bind(this, 1)}
                  // onMouseLeave={this.changeQRState.bind(this, 0)}
                  onClick={() => {
                    this.handleAndroid()
                  }}
                  className="google"
                >
                  {qrCodeState == 1 && (
                    <div className="gg-qrcode">
                      <img src="/img/home/pcnew/google_qr1.png" alt="" />
                    </div>
                  )}
                </div>
                <div
                  // onMouseEnter={this.changeQRState.bind(this, 2)}
                  // onMouseLeave={this.changeQRState.bind(this, 0)}
                  onClick={() => {
                    this.handleApple()
                  }}
                  className="apple"
                >
                  {qrCodeState == 2 && (
                    <div className="apl-qrcode">
                      <img src="/img/home/pcnew/apple_qr.jpg" alt="" />
                    </div>
                  )}
                </div>
                {isShowApkAndRecharge === true && (
                  <div
                    // onMouseEnter={this.changeQRState.bind(this, 3)}
                    // onMouseLeave={this.changeQRState.bind(this, 0)}
                    onClick={() => this.handleApk()}
                    className="apk"
                  >
                    {qrCodeState == 3 && (
                      <div className="apk-qrcode">
                        <img src="/img/home/pc/new_apk2.png" />
                      </div>
                    )}
                  </div>
                )}
                {false && (
                  <div
                    onMouseEnter={this.changeQRState.bind(this, 4)}
                    onMouseLeave={this.changeQRState.bind(this, 0)}
                    onClick={() => this.handleHuaWei()}
                    className="huawei"
                  >
                    {qrCodeState == 4 && (
                      <div className="apk-qrcode">
                        <img src="/img/home/pcnew/huawei.png" />
                      </div>
                    )}
                  </div>
                )}
              </div>
              {false && <div className="big-chatie"></div>}
            </div>
            <div className="right">
              {/* <div className="phone-bor"></div> */}
              {/* <video autoPlay loop muted play="true" playsInline={true} webkit-playsinline="true">
                <source src="/img/home/pcnew/hobi_websiz.mp4" type="video/mp4" />
                Your browser doesn't support video.
              </video> */}
              <img src="/img/home/pic2_new.png" alt="" className="df_bg2" />
              {/* <div className="df_bg"></div> */}
            </div>
          </div>
          <div className="bottom">
            <div className="up">
              <div onClick={this.changeAcState.bind(this, 1)} className="about">
                {lang.about}
              </div>
              <div className="space"></div>
              <div onClick={this.changeAcState.bind(this, 2)} className="contact">
                {lang.contact}
              </div>
              <div className="space"></div>
              {/* <div onClick={() => this.jumpPage()} className="contact">
                Terms of Use
              </div> */}
            </div>
            <div className="down">
              <div className="copyright">Copyright ©2025 {this.state.companyName}</div>
            </div>
          </div>
        </div>

        {/* 弹窗 */}
        {acState != 0 && (
          <div className={`reminder`}>
            <div className="content-txt">
              <div className="title">
                <div className="ct">
                  {acState == 1 && lang.about}
                  {acState == 2 && lang.contact}
                </div>
                <div onClick={this.changeAcState.bind(this, 0)} className="close">
                  x
                </div>
              </div>
              <div className="txt">
                {acState == 1 && <span dangerouslySetInnerHTML={{ __html: lang.aboutCtx }} />}
                {acState == 2 && <span dangerouslySetInnerHTML={{ __html: lang.contactCtx }} />}
              </div>
            </div>
          </div>
        )}

        {/* <div style={{ display: 'none' }} className="hide">
          <img src="/img/home/pcnew/google_qr1.png" alt="" />
          <img src="/img/home/pcnew/apple_qr.jpg" alt="" />
          <img src="/img/home/pcnew/apk_url.png" alt="" />
        </div> */}
        <Toast language={language} lang={lang} ref="toast" id="toast" toastContent={toastContent} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/home/pc/index.js